import client from "../../../api/client";
import mapVerifyOtpPayload from "../utils/mapVerifyOtpPayload";

export default async function verifyLoginOtp(values) {
  const payload = mapVerifyOtpPayload(values);
  const response = await client.post("/auth/verify-otp", payload);
  return response.data;
}